import React from 'react';
import {InvoiceReportComponent} from './InvoiceReport.Component';
import {httpServices}  from '../../../services/httpServices';
import { ErrorPage } from '../../common/error';
import { CustomProgressBar } from '../../common/CustomProgressBar';
import * as _ts from '../../common/treeSelect';
import * as _ms from '../../common/multiSelect';
import * as validations from '../../common/validate';
import MixpanelManager from '../../../services/Analytics';

const filterFields = {
    'report_type': 'emp-wise',
    'staff_status': 1,
    'staff': [],
    'client': [0],
    'projects': [0],
    'tasks' : [],
    'organization' : 0,
    'btn_type': 0,
    'name_format': 'LASTFIRST',
    'project_display': '',
    'task_col_display':'',
    'public' : false
}

const filters = {
    
}
let getProjectTree = function(dataObj, selected_projects, result) {
    dataObj.forEach(function(e) {
        if((selected_projects && selected_projects===e.project_id) || !selected_projects){
            result.push(e.project_id);
            if (e.children) {
                getProjectTree(e.children,0,result);
            }
        }else if(selected_projects && e.children instanceof Object) { 
            getProjectTree(e.children, selected_projects,result);
        }
    });
}
let successMsg = '';
export class InvoiceReportContainer extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            permission : true,
            permission_type : 'all',
            permission_organization_wise: false,
            data : [],
            open: false,
            filterFields: filterFields,
            filters: filters,
            errors: {},
            loaderOpen: false,
            selectedClientList : [],
            selectedStaffList : [],
            
            tabIndex : 0,
            savedSearchClickId : 0,
            fieldChange : false,
            popupType : '',
            saveAction : '',
            logged_user : 0,
            savedSearchCreatedBy : 0,
            saveOpen : false,
            error_msg : '',
            editId : 0,
            savedFilters : [],
            deleteId : 0,
            sharedSearchName : '',
            shareFilterId : 0,
            snackbarOpen : false,
        }
        this.handleTreeChange = this.handleTreeChange.bind(this);
        this.handleTreeDisplayChange = this.handleTreeDisplayChange.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
        this.handlesSaveFilterClick = this.handlesSaveFilterClick.bind(this);
        this.handleUpdateFilterClick = this.handleUpdateFilterClick.bind(this);
        this.saveFilter = this.saveFilter.bind(this);
        this.handleSearchClick = this.handleSearchClick.bind(this);
        this.MixpanelManager = new MixpanelManager();
        this.clearFilter = this.clearFilter.bind(this);
        this.editClick = this.editClick.bind(this);
        this.handleDeleteClick = this.handleDeleteClick.bind(this);
        this.deleteFilter = this.deleteFilter.bind(this);
        this.handleShareClick = this.handleShareClick.bind(this);
        this.shareFilter = this.shareFilter.bind(this);
        this.snackbarClose = this.snackbarClose.bind(this);
        this.getInvoiceReport = this.getInvoiceReport.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.validateFilter = this.validateFilter.bind(this);
    }

    componentDidMount = () => {
        this.getInvoiceReportInputs();
        window.scrollTo(0, 0);
    };
    getInvoiceReportInputs = () => {
        this.setState({loaderOpen:true});
        let filterFields = this.state.filterFields;
        return httpServices.post('api/report/get-invoice-report-inputs', filterFields)
            .then(response => {
                if (response.data && !response.data.errors) {
                    let filters = this.state.filters;
                    let group_manager = this.state.group_manager;
                    let project_manager = this.state.project_manager;
                    let selectedClientList = this.state.selectedClientList;
                    let selectedStaffList = this.state.selectedStaffList;
                        filters = response.data.filters;
                        filters.projects = _ts.prepareTreeData(filters.projects, 'projects');
                        filters.project_display_list = response.data.filters.project_display_list;
                        filters.tasks = _ts.prepareTreeData(filters.tasks, 'tasks');
                        if (filters.staffs.length === 1) {
                            filterFields.staff = [filters.staffs[0].user_id];
                            selectedStaffList = [filters.staffs[0]];
                        }
                        if (filters.organizations.length === 1 && response.data.permission_type !== 'self') {
                            filterFields.organization = filters.organizations[0].client_id;
                        }
                        let clients = _ms.prepareData(filters.clients);
                        filters.clients = clients.list;
                        selectedClientList = clients.selected;
                        filterFields.name_format=response.data.name_format;
                        group_manager = response.data.group_manager;
                        project_manager = response.data.project_manager;
                    this.setState({
                        logged_user : response.data.logged_user,
                        savedFilters: response.data.saved_filters,
                        filters: filters,
                        permission: response.data.permission,
                        permission_type: response.data.permission_type,
                        permission_organization_wise: response.data.permission_organization_wise,
                        group_manager: group_manager,
                        project_manager: project_manager,
                        loaderOpen: false,
                        selectedClientList : selectedClientList,
                        selectedStaffList : selectedStaffList,
                        project_display_name : response.data.project_display_name
                    }, function() {
                        if (filters.organizations.length === 1  && response.data.permission_type !== 'self' && this.state.filterFields.btn_type === 0) {
                            this.getInvoiceStaffList('organization');
                        }
                        this.getUsers();
                    });
                } else if (response.data.errors) {
                    this.setState({
                        errors: response.data.errors,
                        loaderOpen: false
                    });
                }
            })
            .catch(function(error) {
                console.log("Error: "+error);
            });
    };
    getInvoiceReport = () => {
        this.setState({loaderOpen:true});
        let filterFields = this.state.filterFields;
        return httpServices.post('api/report/invoice-report', filterFields)
            .then(response => {
                if (response.data && !response.data.errors) {                   
                    this.setState({
                        data : response.data.data,
                        permission: response.data.permission,
                        permission_type: response.data.permission_type,
                        permission_organization_wise: response.data.permission_organization_wise,
                        post: response.data.post,
                        loaderOpen: false,
                        project_display_name : response.data.project_display_name
                    });
                } else if (response.data.errors) {
                    this.setState({
                        errors: response.data.errors,
                        loaderOpen: false
                    });
                }
            })
            .catch(function(error) {
                console.log("Error: "+error);
            });
    };
    editClick = (id) => {
            let ff = this.state.filterFields;
            if (id) {
                return httpServices.post('api/report/get-saved-filter', {'id' : id})
                .then(response => {
                    if (response.data) {
                        let filter = response.data.filter;
                        ff['title'] = filter.title;
                        ff['description'] = filter.description;
                        ff['public'] = filter.public;                  
                        this.setState({
                            filterFields: ff,
                            saveOpen: true,
                            popupType : 'save_filters',
                            editId : id,
                        });
                    }
                })
                .catch(function (error) {
                    console.log("Error: " + error);
                });
            }
        };
    handleFilterChange = (evt, value) => {
        let f = this.state.filterFields;
        let filters = this.state.filters;
        let name = evt.target.name;
        let val = evt.target.value;
        if (name === 'report_type') {
            f['tasks'] = [];
            filters['tasks'] = [];
            filters['staffs'] = [];
        }
        if (name === 'nbillable' || name === 'detailed' || name === 'remove_footer') {
            f[name] = evt.target.checked;
        }
        else {
            f[name] = val;
        }
        if (evt.target.type && evt.target.type === 'checkbox') {
            f[name] = evt.target.checked;
        }
        this.setState({
            filterFields: f,
            filters: filters,
            fieldChange: true
        });
        if (name === 'report_type') {
            this.clearFilter(name);
        }
        if (name === 'organization' || name === 'staff_status') {
            this.getInvoiceStaffList(name);
        }
    }
    handlesSaveFilterClick = (action) => {
        this.setState({
            popupType: 'save_filters',
            saveOpen: true,
            saveAction : action
        });
    }
    snackbarClose = () => {
        this.setState({
            snackbarOpen : false,
        });
    };
    deleteFilter = () => {
            let apiEndpoint = 'api/report/deleteFilter';
            return httpServices.post(apiEndpoint,{id : this.state.deleteId, 'report' : "invoice-report"})
                .then(response => {
                    if (response.data) {
                        successMsg = "Search deleted successfully";
                        this.setState({
                            snackbarOpen : true,
                            open : false,
                            popupType : '',
                        });
                        this.MixpanelManager.trackEvent('Reports', { 'module': 'Reports', 'feature': 'invoice-report-save-filters', 'action': 'delete-saved-filter' });
                        this.getSavedFilters();
                    }
                })
                .catch(function(error) {
                    console.log("Error: "+error);
                });
    };
     handleShareClick = (id) => {
            let ff = this.state.filterFields;
             return httpServices.post('api/report/get-filter-users', {'id' : id, 'report' : "invoice-report"})
                .then(response => {
                    if (response.data.permission) {
                        let users = response.data.users;
                        if (users) {
                            ff['users'] = users; 
                        }
                        this.setState({
                            popupType: 'share_filter',
                            saveOpen: true,
                            shareFilterId : id,
                            filterFields: ff,
                            sharedSearchName: response.data.filter_title
                        });
                    }
            })
            .catch(function(error) {
                console.log("Error: "+error);
            });
           
    }
    getUsers() {
        httpServices.post('api/report/get-all-users', { 'report' : "invoice-report" })
            .then(response => {
                if (response.data) {
                    let filters = this.state.filters;
                    filters['user_list'] = _ts.prepareTreeData(response.data, 'users', false);
                    this.setState({
                        filters: filters
                    });
                }
            })
    }
    updateFilter = () => {
            let filterFields = this.state.filterFields;
            this.MixpanelManager.trackEvent('Reports', { 'module': 'Reports', 'feature': 'invoice-report-save-filters', 'action': 'updated-saved-filter-details' });
            return httpServices.post('api/report/updateSavedFilter', {'title': filterFields.title, 'description': filterFields.description, 'id': this.state.editId, 'public': filterFields.public})
                .then(response => {
                    if (response.data && response.data.status) {
                        successMsg = "Saved Search updated successfully";
                        filterFields['title'] = '';
                        filterFields['description'] = '';
                        filterFields['public'] = false;
                        this.setState({
                            loaderOpen: false,
                            popupType: '',
                            saveOpen: false,
                            snackbarOpen: true,
                            editId: 0,
                            filterFields: filterFields
                        })
                        this.getSavedFilters();
                        this.handleTabChange(1);
                    }
                    else {
                        this.setState({
                            error_msg: response.data.error_msg,
                            loaderOpen: false,
                        })
                    }
    
                })
                .catch(function (error) {
                    console.log("Error: " + error);
                });    
    }
    getSavedFilters = () => {
            return httpServices.post('api/report/getSavedInvoiceReportFilters')
            .then(response => {
                if (response.data && response.data.permission) {
                    this.setState({
                        savedFilters: response.data.saved_filters,
                    })
                }
            })
            .catch(function (error) {
                console.log("Error: " + error);
            });
    }
    shareFilter = () => {
        let ff = this.state.filterFields;
        this.MixpanelManager.trackEvent('Reports', { 'module': 'Reports', 'feature': 'invoice-report-save-filters', 'action': 'filter-shared' });
        return httpServices.post('api/report/shareFilter', { 'users': ff.users, 'id': this.state.shareFilterId, 'report' : "invoice-report" })
            .then(response => {
                if (response.data && response.data.permission) {
                    successMsg = "Search shared successfully";
                    this.setState({
                        loaderOpen: false,
                        popupType: '',
                        saveOpen: false,
                        snackbarOpen: true,
                    })
                }

            })
            .catch(function (error) {
                console.log("Error: " + error);
            });
    }
    saveFilter = () => {
        if ((!this.state.filterFields.title || this.state.filterFields.title.trim() == "") && this.state.saveAction == "saveas") {
            this.setState({
                error_msg: "Title cannot be empty",
            })
        }
        else {
            if (this.state.editId) {
                this.updateFilter();
            }
            else {
                let filterFields = this.state.filterFields;
                return httpServices.post('api/report/saveInvoceReportFilter', {
                    'staff': filterFields.staff,
                    'projects': filterFields.projects,
                    'client': filterFields.client,
                    'save': true,
                    'tasks': filterFields.tasks,
                    'start_date': filterFields.start_date,
                    'end_date': filterFields.end_date,
                    'name_format': filterFields.name_format,
                    'nbillable': filterFields.nbillable,
                    'organization': filterFields.organization,
                    'project_display': filterFields.project_display,
                    'project_display_name': filterFields.project_display_name,
                    'public': filterFields.public,
                    'remove_footer': filterFields.remove_footer,
                    'report_type': filterFields.report_type,
                    'staff_status': filterFields.staff_status,
                    'task_col_display': filterFields.task_col_display,
                    'title': filterFields.title,
                    'description': filterFields.description,
                    'id': this.state.editId,
                    'detailed' : filterFields.detailed,
                    'update_id': this.state.savedSearchClickId,
                    'save_action': this.state.saveAction
                })
                    .then(response => {
                        if (response.data && response.data.status) {
                            successMsg = this.state.saveAction == "save" ? "Saved Search updated successfully" : "Search saved successfully";
                            filterFields['title'] = '';
                            filterFields['description'] = '';
                            filterFields['public'] = false;
                            this.setState({
                                loaderOpen: false,
                                popupType: '',
                                saveOpen: false,
                                snackbarOpen: true,
                                editId: 0,
                                ReportFields: filterFields
                            })
                            this.getSavedFilters();
                            this.handleTabChange(1);
                            this.MixpanelManager.trackEvent('Reports', { 'module': 'Reports', 'feature': 'invoice-report-save-filters', 'action': 'filter-saved' });
                        }
                        else {
                            this.setState({
                                error_msg: response.data.error_msg,
                                loaderOpen: false,
                            })
                        }

                    })
                    .catch(function (error) {
                        console.log("Error: " + error);
                    });
            }
        }
    }
    handleUpdateFilterClick = (action) => {
        if (action == "save" && this.state.savedSearchClickId) {
            this.setState({               
                saveAction : action
            }, (() => this.saveFilter()));
        }
        else
        {
            this.handlesSaveFilterClick("saveas");
        }
    }
    formSubmit = () => {
        this.validateFilter();
    }
    submitSavedSearch = () => {
        this.setState({
            fieldChange: false
        }, (() => this.formSubmit()));
    }
    handleDeleteClick = (id) => {
        if (id) {
            this.setState({
                saveOpen : true,
                popupType : 'delete',
                deleteId : id,
            });
        }
    };
    handleSearchClick = async (id, cby) => {
        let ff = { ...this.state.filterFields };
        let filters = this.state.filters;

        this.setState({
            savedSearchClickId: id,
            savedSearchCreatedBy: cby,
            tabIndex: 0
        });

        try {
            const response = await httpServices.post('api/report/getSavedInvoiceFilter', { id });
            if (!response.data) return;

            const filterOptions = response.data.filter_options;

            // Map filter options to filterFields
            Object.keys(filterOptions).forEach(key => {
                if (["staff", "projects", "client", "tasks"].includes(key)) {
                    const arr = Array.isArray(filterOptions[key])
                        ? filterOptions[key]
                        : [filterOptions[key]];

                    ff[key] = arr.map(Number);
                } else {
                    ff[key] = filterOptions[key];
                }
            });

            // Filter clients
            if (ff['client']) {
                const allowedIds = ff['client'];
                const filteredClients = filters.clients.filter(
                    c => allowedIds.includes(c.client_id) && c.client_id !== 0
                );
                this.setState({ selectedClientList: filteredClients });

                if (filteredClients.length === 0) {
                    ff['client'] = [0];
                }
            }

            if (ff['projects']) {
                await this.getTasksByProject(ff['projects'], filterOptions['report_type'] ?? '');
                const allowedTaskIds = ff['tasks'];
                const filteredTasks = filters.tasks.filter(t => allowedTaskIds.includes(t.task_id));
                this.handleTreeChange("evt_saved_search", filters.tasks, filteredTasks, "tasks");

                if (ff['staff']) {
                    const allowedStaffIds = ff['staff'];
                    const filteredStaffs = filters.staffs.filter(
                        c => allowedStaffIds.includes(c.user_id) && c.user_id !== 0
                    );
                    this.setState({ selectedStaffList: filteredStaffs });

                    if (filteredStaffs.length === 0) {
                        ff['staff'] = [];
                    }
                }
            }
            this.setState({ filterFields: ff }, () => {
                this.submitSavedSearch();
            });

            this.MixpanelManager.trackEvent('Reports', {
                module: 'Reports',
                feature: 'invoice-report-save-filters',
                action: 'search-saved-filter'
            });
        } catch (error) {
            console.log("Error: " + error);
        }
    };
    
    handleTreeDisplayChange = (evt, cNode, sNodes, action) => {
        let project = 0;
        let formValues = this.state.filterFields;
        if (sNodes.length < 1) {
            project = 0;
        }
        else if (cNode.project_id) {
            project = cNode.project_id;
        }
        if (project) {
            formValues['project_display_name'] = cNode.project_name;
            formValues['project_display'] = project;
        }
        else {
            formValues['project_display_name'] = '';
            formValues['project_display'] = 0;
        }
        this.setState({ filterFields : formValues, fieldChange : true});
    }
    handleTreeChange = (evt = '', cNode, sNodes, action) => {
        let f = this.state.filterFields;
        let projects = [];
        let tasks = [];
        let users = [];
        let filters = this.state.filters;
        if (cNode.value === 'selectAll') {
                if (cNode.checked) {
                    if (action === 'project') {
                        projects.push(0)
                    }
                    else if (action === 'tasks') {
                        tasks.push(0);
                    }
                    else if (action === 'users') {
                        users.push(0);
                    }
                }
            }
            else {
                if (sNodes && sNodes.length >= 0) {
                sNodes.forEach(function(el){
                    if (el.project_id || el.task_id || el.user_id || el.client_id) {
                        if (action === 'project') {
                            getProjectTree(filters.projects, el.project_id, projects);
                        } else if (action === 'tasks') {
                            tasks.push(el.task_id);
                        }
                        else if (action === 'users') {
                            users.push(el.user_id);
                        }

                    }
                });
            }
        }
        if (action === 'project') {
            f['projects'] = projects;
            f['tasks'] = [];
        } else if (action === 'tasks') {
            f['tasks'] = tasks;
        }
        else if (action === 'users') {
            f['users'] = users;
        }
        let fchange = evt == "evt_saved_search" ? false : true;
        this.setState({filterFields : f, fieldChange : fchange},function(){
            if (action === 'project') {
                this.getTasksByProject(projects);
            } 
        });
    }
    
    clearFilter = (name) => {
        let f = this.state.filterFields;
        let report_type = f.report_type;
        let start_date = (name === 'report_type') ? f.start_date : '';
        let end_date = (name === 'report_type') ? f.end_date : '';
        let name_format = f.name_format;
        let projects = [0];
        let client = [0];
        if (name === 'report_type') {
            projects = f.projects;
            client = f.client;
        }
        let filterFields = {
            'report_type': report_type,
            'staff_status': 1,
            'staff': [],
            'client': client,
            'projects': projects,
            'tasks' : [0],
            'organization' : 0,
            'start_date': start_date,
            'end_date': end_date,
            'btn_type' : 0,
            'name_format' : name_format,
            'project_display': '',
            'task_col_display':'' 
        }
        this.setState({
            filterFields: filterFields,
            savedSearchClickId : 0,
            fieldChange : false,
            data: [],
            post: false,
            errors: [],
        }, function() {
            if (name === 'report_type') {
                this.getProjectsByClient(name);
            }
        })
    }
    getProjectsByClient = (name) => {
        let client_id = this.state.filterFields.client;
        let report_type = this.state.filterFields.report_type;
        let staff_status = this.state.filterFields.staff_status;
        let organization = this.state.filterFields.organization;
        let start_date = this.state.filterFields.start_date;
        let end_date = this.state.filterFields.end_date;
        let include_project_all_option = (report_type === 'emp-wise') ? true : false;
        let include_staff_all_option = true;
        let filterFields = this.state.filterFields;
        let selectedStaffList = this.state.selectedStaffList;
        let selectedClientList = this.state.selectedClientList;

        return httpServices.post('api/report/getInvoiceFilter', {client_id : client_id, report_type : report_type, staff_status : staff_status, organization : organization, start_date : start_date, end_date : end_date})
            .then(response => {
                if (response.data) {
                    let filters = this.state.filters;
                    filters.projects = _ts.prepareTreeData(response.data.projects, 'projects', include_project_all_option);
                    if (response.data.clients) {
                        let clients = _ms.prepareData(response.data.clients);
                        filters.clients = clients.list;
                        selectedClientList = clients.selected;
                    }
                    if (name === 'report_type') {
                        if (report_type === 'emp-wise' && response.data.staff.length === 1) {
                            filterFields.staff = response.data.staff[0]['user_id'];
                            include_staff_all_option = false;
                            selectedStaffList = [response.data.staff[0]];
                        }
                        else if (report_type === 'emp-wise' && filterFields.organization === 0) {
                            include_staff_all_option = false;
                        }
                        let staffs = _ms.prepareData(response.data.staff, include_staff_all_option);
                        filters.staffs = staffs.list;
                        if (include_staff_all_option) {
                            selectedStaffList = staffs.selected;
                        }
                    }
                    if (this.state.filterFields.projects[0] !== 0) {
                        let sprojects = [];
                        this.manageSelectedProjects(this.state.filters.projects, this.state.filterFields.projects, sprojects);
                        filterFields.projects = sprojects;
                    }
                    this.setState({
                        filters : filters,
                        filterFields: filterFields,
                        selectedStaffList : selectedStaffList,
                        selectedClientList : selectedClientList,
                    }, function() {
                        this.getTasksByProject(filterFields.projects);
                    }

                    );
                }
            })
            .catch(function(error) {
                console.log("Error: "+error);
            });
    }
    getTasksByProject = (projects, type = '') => {
        let staff_status = this.state.filterFields.staff_status;
        let filterFields = this.state.filterFields;
        let selectedStaffList = this.state.selectedStaffList;
        return httpServices.post('api/report/getTasksByProjects', {projects : JSON.stringify(projects), staff_status: staff_status})
            .then(response => {
                if (response.data) {
                    let filters = this.state.filters;
                    let tasks = response.data.tasks;
                    // Sort the tast based on the selected project tree 
                    let sorted_tasks = [];
                    projects.forEach((p) =>{
                        if (p) {
                            if (tasks && tasks.length) {
                                tasks.forEach((task) => {
                                    if (task.task_project === p) {
                                        let json_task = JSON.stringify(task);
                                        sorted_tasks.push(json_task);
                                    }
                                });
                            }
                        } 
                    });
                    filters.tasks = _ts.prepareTreeData(sorted_tasks, 'tasks');
                    if (response.data.tasks.length > 0) {
                        filterFields.tasks = [0];
                    }
                    let report_type_val = this.state.filterFields.report_type;
                    if (type != '') {
                        report_type_val = type;
                    }
                    if (report_type_val === 'project-wise') {
                        if (response.data.staffs) {
                            let staffs = _ms.prepareData(response.data.staffs);
                            filters.staffs = staffs.list;
                            selectedStaffList = staffs.selected;
                            if (response.data.staffs.length > 0) {
                                filterFields.staff = [0];
                            }
                        }
                        else {
                            filters.staffs = [];
                            selectedStaffList = [];
                        }
                    }
                    this.setState({
                        filters : filters,
                        selectedStaffList : selectedStaffList,
                    });
                }
            })
            .catch(function(error) {
                console.log("Error: "+error);
            });
    }
    getInvoiceStaffList = (field) => {
        let filterFields = this.state.filterFields;
        let staff_status = filterFields.staff_status;
        let organization = filterFields.organization;
        let projects = filterFields.projects;
        let report_type = filterFields.report_type;
        let start_date = filterFields.start_date;
        let end_date = filterFields.end_date;
        let include_project_all_option = true;
        let selectedStaffList = [];
        let selectedClientList = [];
        let include_all_option = false;
        if ((report_type === 'project-wise' && projects.length > 0 && projects[0] !== 0) || (report_type === 'emp-wise' && organization > 0)) {
            include_all_option = true;
        }
         return httpServices.post('api/report/getInvoiceStaffList', {staff_status: staff_status, organization: organization, projects: projects, report_type: report_type, field: field, start_date: start_date, end_date: end_date})
            .then(response => {
                if (response.data) {
                    let filters = this.state.filters;
                    let staffs = _ms.prepareData(response.data.staffs, include_all_option);
                    filters.staffs = staffs.list;
                    if (this.state.selectedStaffList) {
                        this.state.selectedStaffList.forEach((selectedStaffDetails) => {
                            selectedStaffList.push(selectedStaffDetails);
                        });
                    }
                    if (include_all_option) {
                        selectedStaffList = staffs.selected;
                        filterFields.staff = [0]
                    }
                    else {
                        if (report_type === 'emp-wise' && response.data.staffs.length === 1) {
                            filterFields.staff = response.data.staffs[0]['user_id'];
                            selectedStaffList = [response.data.staffs[0]];
                        }
                        else {
                            filterFields.staff = response.data.staffs[0]['user_id'];
                        }
                    }
                    if(field==='organization'){
                        if (response.data.projects) {
                            filters.projects = _ts.prepareTreeData(response.data.projects, 'projects', include_project_all_option);
                        }
                        if (response.data.clients) {
                            let clients = _ms.prepareData(response.data.clients);
                            filters.clients = clients.list;
                            selectedClientList = clients.selected;
                        }
                    }else{ 
                        selectedClientList=this.state.selectedClientList;
                    }
                    this.setState({
                        filters : filters,
                        filterFields: filterFields,
                        selectedStaffList : selectedStaffList,
                        selectedClientList : selectedClientList,
                    });
                }
            })
            .catch(function(error) {
                console.log("Error: "+error);
            });
    }
    validateFilter = () => {
        let valid = this.validate();
        let f = this.state.filterFields;
        f.btn_type = 'filter';
        this.setState({filterFields: f},
            function() {
                if (valid) {
                    this.getInvoiceReport();
                }

            }
        );
    }
    validateExport = (name) => {
        let f = this.state.filterFields;
        f.btn_type = name;

        this.setState({filterFields: f}, function () {

            let valid = this.validate();

            if (valid) {
                let data = JSON.stringify(this.state.filterFields);
                data = JSON.parse(data);
                data.projects = data.projects.toString();
                data.staff = data.staff.toString();
                data.tasks = data.tasks.toString();
                return httpServices.post('api/report/validate-invoice-timesheet', data)
                    .then(response => {
                        if (response.data) {
                            let valid = response.data.valid;
                            if (valid) {
                                document.getElementById("invoiceForm").submit();
                            }
                            else {
                                this.setState({
                                    open : true,
                                    warning_timesheets: response.data.warning_timesheets,
                                });
                            }
                        }
                    })
                    .catch(function(error) {
                        console.log("Error: "+error);
                    });
            }
        });
    }
    validate = () => {
        let formIsValid = true;
        let validationData = [
            { name: 'start_date', value: this.state.filterFields.start_date, type: 'date', otherOptions: { required: true } },
            { name: 'end_date', value: this.state.filterFields.end_date, type: 'date', otherOptions: { required: true } }
        ]
        let validateResponse = validations.validateFormElements(validationData);
        let validateErrors = validateResponse.errors;
        let isValid = validateResponse.valid;
        if (isValid) {
            let errors = {};
            if (this.state.filterFields.start_date && this.state.filterFields.end_date) {
                if (new Date(this.state.filterFields.start_date) > new Date(this.state.filterFields.end_date)) {
                    errors["start_date"] = "Start Date should be less than End Date";
                }
            }
            if (this.state.filterFields.report_type === 'emp-wise') {
                if (this.state.permission_type === 'all' || (this.state.permission_type === 'self' && this.state.group_manager)) {
                    if (parseInt(this.state.filterFields.organization) === 0 && this.state.filterFields.staff.length === 0) {
                        errors["organization"] = "Organization or Staff required";
                        errors["staff"] = "Organization or Staff required";
                        formIsValid = false;
                    }
                }
                else {
                    if (this.state.filterFields.staff.length === 0) {
                        errors["staff"] = "Staff required";
                        formIsValid = false;
                    }
                }
            }
            if (this.state.filterFields.report_type === 'project-wise') {
                if (this.state.filterFields.projects.length === 0 || (this.state.filterFields.projects.length === 1 && this.state.filterFields.projects[0] === 0)) {
                    errors["projects"] = "Projects required";
                    formIsValid = false;
                }
            }
            this.setState({ errors: errors });
        } else {
            formIsValid = false;
            this.setState({ errors: validateErrors });
        }
        return formIsValid;
    }
    onClose = () =>{
        let f = this.state.filterFields;
        f['title'] = '';
        f['description'] = '';
        f['public'] = false;
        f['users'] = [];
        this.setState({
            open: false,
            saveOpen: false,
            error_msg : '',
            filterFields : f
        });
        setTimeout(() => this.setState({ editId: 0 }), 300);
    };
    confirmTimesheetValidation = () => {
        document.getElementById("invoiceForm").submit();
        this.setState({
            open: false,
        });
    };

    onSelect = (selectedList, selectedItem) => {
        let selected = [];
        let f = this.state.filterFields;
        let selectedClientList = this.state.selectedClientList;
        let selectedStaffList = this.state.selectedStaffList
        if (typeof selectedItem.client_id !== 'undefined') {
            if (selectedItem.client_id !== 0) {
                if(selectedList[0].client_id === 0) {
                    selectedList.splice(0,1);
                }
            }
            else {
                selectedList = [{client_id:0,client_name:"All Clients"}]
            }
            selectedList.forEach((p, v) =>{
                selected.push(p.client_id);
            })
            selectedClientList = selectedList;
            f.client = selected;
        }
        if (typeof selectedItem.user_id !== 'undefined') {
            if (selectedItem.user_id !== 0) {
                if(selectedList[0].user_id === 0) {
                    selectedList.splice(0,1);
                }
            }
            else {
                selectedList = [{user_id:0,full_name:"All Staff"}]
            }
            selectedList.forEach((p, v) =>{
                selected.push(p.user_id);
            })
            selectedStaffList = selectedList;
            f.staff = selected;

        }
        this.setState({
            filterFields: f,
            selectedClientList : selectedClientList,
            fieldChange : true,
            selectedStaffList : selectedStaffList,
        }, function() {
            if (typeof selectedItem.client_id !== 'undefined') {
                this.getProjectsByClient('client');
            }
        });
    }
    onRemove(selectedList, removedItem) {
        let selected = [];
        let f = this.state.filterFields;
        if (typeof removedItem.client_id !== 'undefined') {
            selectedList.forEach((p, v) =>{
                selected.push(p.client_id);
            })
            f.client = selected;

        }
        if (typeof removedItem.user_id !== 'undefined') {
            selectedList.forEach((p, v) =>{
                selected.push(p.user_id);
            })
            f.staff = selected;
        }
        this.setState({
            fieldChange : true,
            filterFields: f,
        },function() {
            if (typeof removedItem.client_id !== 'undefined') {
                this.getProjectsByClient('client');
            }
        });
    }
    manageSelectedProjects = (projects, selectedprojects, sprojects) => {
        projects.forEach((p, v) =>{
            if (p.project_id) {
                if (selectedprojects.indexOf(p.project_id) >= 0) {
                    sprojects.push(p.project_id);
                }
            }
            if (p.children instanceof Object) {
                this.manageSelectedProjects(p.children, selectedprojects, sprojects);
            }
        })
        return sprojects;
    }
    handleTabChange = (tab) => {
        this.setState({
            tabIndex : tab           
        });
    }
    render() {
        const { permission, filters } = this.state;
        const isFiltersReady = filters && filters.report_types && filters.report_types.length > 0;
        if (!isFiltersReady) {
            return (<CustomProgressBar
                loaderOpen={true}
            />)
        }
        return (
            (permission) ?
                <InvoiceReportComponent
                    HandleFilterChange={this.handleFilterChange}
                    ValidateFilter={this.validateFilter}
                    GetInvoiceReport={this.getInvoiceReport}
                    ClearFilter={this.clearFilter}
                    {...this.state}
                    HandleTreeChange={this.handleTreeChange}
                    ValidateExport={this.validateExport.bind(this)}
                    OnClose={this.onClose.bind(this)}
                    ConfirmTimesheetValidation={this.confirmTimesheetValidation.bind(this)}
                    OnSelect={this.onSelect.bind(this)}
                    OnRemove={this.onRemove.bind(this)}
                    HandleTreeDisplayChange={this.handleTreeDisplayChange}
                    TabIndex={this.state.tabIndex}
                    HandleTabChange={this.handleTabChange}
                    SavedSearchClickId={this.state.savedSearchClickId}
                    FieldChange={this.state.fieldChange}
                    PopupType={this.state.popupType}
                    LoggedUser={this.state.logged_user}
                    SavedSearchCreatedBy={this.state.savedSearchCreatedBy}
                    HandlesSaveFilterClick={this.handlesSaveFilterClick}
                    HandleUpdateFilterClick={this.handleUpdateFilterClick}
                    SaveOpen={this.state.saveOpen}
                    SaveFilter={this.saveFilter}
                    ErrorMessage={this.state.error_msg}
                    EditId={this.state.editId}
                    Message={successMsg}
                    SavedFilters={this.state.savedFilters}
                    HandleSearchClick={this.handleSearchClick}
                    EditClick={this.editClick}
                    HandleDeleteClick={this.handleDeleteClick}
                    DeleteFilter={this.deleteFilter}
                    SharedSearchName={this.state.sharedSearchName}
                    HandleShareClick={this.handleShareClick}
                    ShareFilter={this.shareFilter}
                    snackbarOpen={this.state.snackbarOpen}
                    SnackbarClose={this.snackbarClose}
                />
                :
                <ErrorPage />
        )
    }
}
